import { render, staticRenderFns } from "./technician.vue?vue&type=template&id=6d9506c5&scoped=true&"
import script from "./technician.vue?vue&type=script&lang=js&"
export * from "./technician.vue?vue&type=script&lang=js&"
import style0 from "./technician.vue?vue&type=style&index=0&id=6d9506c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9506c5",
  null
  
)

export default component.exports